import React, { useEffect, useState } from "react"
import useLoader from "../../../../shared/components/loading-dialog/useLoader.hook";
import useReportingAndAnalyticsApi from "../../../pages/reporting-and-analytics/useReportingAndAnalyticsApi";
import LoadingDialogComponent from "../../../../shared/components/loading-dialog/loading-dialog.component";
import useWizardReportDataContext from "../contexts/useWizardReportData.context";


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export function useGetAvailableColumnsApi() {

    const [dataSourceViewNames, setDataSourceViewNames] = useState<string[]>([]);
    const { getAvailableColumns } = useReportingAndAnalyticsApi();
    const { availableColumns, setAvailableColumns } = useWizardReportDataContext();

    useEffect(() => {
        setAvailableColumns([]);
        if (dataSourceViewNames?.length) {
            availableColumnsLoader.loadAsync();
        }
    }, [dataSourceViewNames])

    const availableColumnsLoader = useLoader({
        loaderName: "Available Columns",
        loadAsync: () =>
            getAvailableColumns(
                {
                    // TODO: later when multiple ds are implemented
                    // pass the array instead of single element
                    dataSourceName: dataSourceViewNames[dataSourceViewNames.length - 1]
                },
                {
                    doIf: () => availableColumnsLoader.isNotLoading,
                    doBefore: () => {
                        setAvailableColumns([]);
                        availableColumnsLoader.SET_LOADING("Fetching Available Columns...");
                    },
                    onFulfilled: (data) => {
                        let columns = Array.isArray(data.columns) ? data.columns : [];
                        setAvailableColumns(columns);
                        availableColumnsLoader.SET_SUCCESS("Success.!");
                    },
                    onException: availableColumnsLoader.SET_EXCEPTION,
                }
            ),
    });


    const availableColumnsProgressComponent = () => {
        return <LoadingDialogComponent loaderHook={availableColumnsLoader} />
    }

    return {
        setDataSourceViewNames,
        dataSourceViewNames,
        availableColumns,
        availableColumnsProgressComponent,
        availableColumnsLoader,
    }
}